
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/contribuir",
      function () {
        return require("private-next-pages/contribuir.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/contribuir"])
      });
    }
  